import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ColetaService } from 'src/services/coleta.service';
import { TipoColetaService } from 'src/services/tipo-coleta.service';
import * as moment from 'moment';
import { PermissoesService } from 'src/services/permissoes.service';

@Component({
    selector: 'app-modelo-email',
    templateUrl: './modelo-email.component.html',
    styleUrls: ['./modelo-email.component.scss'],
    standalone: false
})
export class ModeloEmailComponent implements OnInit{
  text: any
  direitoSalvar: boolean = false;

  constructor(
    protected permissaoService: PermissoesService,
  ) { }
  ngOnInit(): void {
    this.direitoSalvar = this.permissaoService.can('modelo_email_salvar');
  }

  

  save(){
  
  }


}
